<template>
  <div>
    <div class="login-wrapper">
      <div class="login">
        
        <div style="display: block; text-align: center">
          <img alt="Logo" src="@/assets/erickson-logo.png" style="width: 92%;"/>
          <!-- 華人艾瑞克森催眠治療學會 -->
        </div>

        <!-- use el-form to validate fields -->
        <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="0"
            class="demo-ruleForm"
        >
          <el-form-item prop="empno">
            <el-input v-model="ruleForm.empno" prefix-icon="el-icon-user" auto-complete="on"
                      :placeholder="$t('message.account')"></el-input>

          </el-form-item>
          <el-form-item prop="password">
            <el-input show-password v-model="ruleForm.password" prefix-icon="el-icon-lock" auto-complete="on"
                      :placeholder="$t('message.password')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="login('ruleForm')" style="width:100%;">{{ $t('buttons.login') }}</el-button>
          </el-form-item>
          <el-form-item v-if="devMode=='Y'">
            <div><span style="color:red; text-align: center; font-weight: bold;">此為測試區</span></div>
          </el-form-item>
        </el-form>
        <div class="text-right">
          <el-button type="text" @click="dialogFormVisible = true">忘記密碼?</el-button>
        </div>
      </div>
    </div>

    <div>
      <el-dialog title="忘記密碼"
               :visible.sync="dialogFormVisible"
               width="350px" class="myform">
        <el-form :model="requestForm" label-position="top" :rules="requestFormRules" ref="requestForm" label-width="80px">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="登入帳號(email)">
                <el-input v-model="requestForm.empno" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <span>送出後，密碼將會寄到您的email</span>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="requestPass('requestForm')">送出</el-button>
        </div>
      </el-dialog>
      </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import store from '@/store'

export default {
  name: 'Login',
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        // callback(new Error('請輸入資料'))
        callback(new Error(this.$t('message.required_field')))
      } else {
        callback()
      }
    }
    return {
      appVersion: localStorage.getItem('ER_VERSION'),
      // showLoading: true,
      imgUrl: require('@/assets/images/14.png'),
      ruleForm: {
        empno: '',
        password: ''
      },
      devMode: process.env.VUE_APP_DEV_MODE,
      rules: {
        empno: [{validator: checkName, trigger: 'change'}]
      },

      dialogFormVisible:false,
      requestForm:{
        empno:''
      },
      requestFormRules: {
        empno: [{validator: checkName, trigger: 'change'}]
      }
    }
  },
  mounted() {
    let bgImg = new Image()
    bgImg.src = this.imgUrl
    bgImg.onerror = () => {
      console.log('img onerror')
    }
    // bgImg.onload = () => {
    //   this.showLoading = false
    // }

    this.checkReload()
  },
  methods: {
    ...mapMutations({
      bindLogin: 'BIND_LOGIN',
      saveUser: 'SAVE_USER'
    }),
    checkReload(){
      console.log('appVersion:', this.appVersion)
      console.log('static version:', this.version)
      if (this.appVersion === null) {
        localStorage.setItem('ER_VERSION', this.version)
        location.reload()
      } else {
        if (this.appVersion !== this.version) {
          localStorage.setItem('ER_VERSION', this.version)
          this.appVersion = this.version
          window.location.reload()
        }
      }
    },
    login(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {

          try {
            
            await this.$store.dispatch('login/submitLoginForm', this.ruleForm)

            this.$notify({
              title: this.$t('message.success'),
              message: this.$t('login.success'),
              duration: 1000,
              type: 'success'
            })
            setTimeout(() => {
              console.log('after login')

              //判斷是否為第一次登入
              console.log('判斷是否為第一次登入:',store.state.login.userInfo.forceChangePwd)
              if (store.state.login.userInfo.forceChangePwd === 'Y') {
                this.$router.push({path: '/data/users/change_password'})
              } else {
                let toPath = this.$route.query.redirect
                if (typeof toPath !== 'undefined' && toPath !== '') {
                  this.$router.push({path: toPath})
                } else {
                  this.$router.push({path: '/'})
                }
              }


            }, 500)
          } catch (e) {
            console.log('login ee:', e)
            this.$notify({
              title: this.$t('message.error'),
              message: this.$t('login.failed'),
              duration: 3000,
              type: 'error'
            })
          }


        }
      })
    },
    requestPass(){
      let query = {
        email: this.requestForm.empno
      }
      this.request.get("/user/requestPass", {params: query}).then(res => {
        this.dialogFormVisible = false
        this.requestForm.empno = ''
        if (res.code === '200') {
          this.$alert('密碼已寄出', '提醒', {
            confirmButtonText: 'OK'
          });
        } else {
          this.showResult('error', '查無此帳號，請重新輸入')
        }
      })
      
    }
  }
}
</script>
<style scoped>
.loading-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  /*background: #aedff8;*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  /*background-color: #f5f8fa;*/

/*  background-image: url('~@/assets/images/big-roupe-joyshot.png');*/
  background-repeat: no-repeat;
  background-size: 1000px;
  background-attachment: fixed;
  background-position: center bottom;
}

.login-wrapper img {
  /*position: absolute;*/
  /*z-index: 0;*/
}

.login {
  max-width: 340px;
  margin: 80px auto;
  background: white;
  padding: 20px 40px;
  border-radius: 10px;
  position: relative;
  margin-top: 200px;

  -webkit-box-shadow: 0 .1rem 1rem .25rem rgba(0, 0, 0, .15);
  box-shadow: 0 .1rem 1rem .25rem rgba(0, 0, 0, .15);
  /*z-index: 9;*/
}

.title {
  font-size: 26px;
  line-height: 50px;
  font-weight: bold;
  margin: 10px;
  text-align: center;
}

#login-form > input {
  width: 100%;
  height: 34px;
  display: block;
  margin-top: 26px;
  background: #fff;
  color: #333;
  border: 1px solid #7da9c7;
  outline: none;
  text-indent: 20px;
  font-size: 14px;
}

#login-form > button {
  width: 100%;
  height: 34px;
  display: block;
  margin-top: 26px;
  background: #1ab2ff;
  color: #fff;
  border: 1px solid #1ab2ff;
  outline: none;
  border-radius: 100px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.register {
  margin-top: 10px;
  font-size: 14px;
  line-height: 22px;
  text-indent: 8px;
  color: #1ab2ff;
  cursor: pointer;
  display: inline-block;
}

.register:hover {
  color: #2c2fd6;
}

.demo-ruleForm {
  margin-top: 20px;
}

.page-bg {
  position: absolute;
  z-index: -1;
}

@media (max-width: 768px) {
  .login {
    max-width: 260px;
    margin: 60px auto;
    background: #fff;
    padding: 20px 20px;
    border-radius: 10px;
    position: relative;
    /*z-index: 9;*/
  }
}
</style>
